import { homeownerQuotesService } from '@/services/quotes/homeowner';
import { useMutation } from '@tanstack/react-query';

export function useValidateInspectionJourney() {
  return useMutation<
    { success: boolean; error?: string; message?: string },
    Error,
    string
  >({
    mutationKey: ['quotes', 'validate-inspection-journey'],
    mutationFn: async (policyId: string) => {
      const response = await homeownerQuotesService.validateInspectionJourney(policyId);

      if (!response.success) {
        throw new Error(response.error || 'Erro ao validar inspeção');
      }

      return response;
    },
  });
}
